module.exports = __webpack_public_path__ + "static/media/at.892a24c1.699bcf75.svg";